// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"LzPI-","separator":"_2rn_Z","listContainer":"_315Tz"};